import * as React from "react";
import styles from "./contactform.module.scss";
import { useContactFormContext } from "./Context";
import { ContactRequest, OrderInfo, TicketType } from "./types";
import { ContactSourceType } from "./ContactForm";

export const ContactMessageForm: React.FC<{
  OrderInfo: OrderInfo;
  onMessageSave: (message: ContactRequest) => void;
  Source: ContactSourceType;
  onNeedRefresh: (ticketId: number) => void;
}> = (props) => {
  const context = useContactFormContext();

  const [formError, setError] = React.useState("");

  const [ticketTypes, setTicketTypes] = React.useState<TicketType[]>([]);

  const useStringLimiter = (
    defaultValue: string,
    maxLength: number
  ): [string, (value: string) => void] => {
    const [value, setValue2] = React.useState(defaultValue);

    const setValue = (newValue: string) => {
      if (value.length > maxLength) {
        setValue2(newValue.substring(0, maxLength));
      } else {
        setValue2(newValue);
      }
    };

    return [value, setValue];
  };

  const [message, setMessage] = useStringLimiter("", 500);

  const [ticketType, setTicketType] = React.useState(
    props.OrderInfo.TicketType
  );
  const [ticketId, setTicketId] = React.useState(props.OrderInfo.TicketId);

  const getData = React.useCallback(async () => {
    const response = await context.GetTicketTypes();
    setTicketTypes(response);
  }, [context]);

  React.useEffect(() => {
    getData();
  }, [getData]);

  async function handleClick(e: React.MouseEvent): Promise<void> {
    e.preventDefault();

    if (ticketType === 0) {
      setError("Please select a subject");
      return;
    }
    if (message.length < 10) {
      setError(
        "Please provide as much info as you can to help us understand your request"
      );
      return;
    }

    const message1: ContactRequest = {
      ...props.OrderInfo,
      TicketType: ticketType,
      TicketId: ticketId,
      Message: message,
      Source: props.Source,
    };
    props.onMessageSave(message1);
  }

  let buttonText = "Send Message";
  if (ticketId > 0) {
    buttonText = "Send Response";
  }
  function handleClearTicket(e: React.MouseEvent): void {
    e.preventDefault();
    props.onNeedRefresh(0); //
    setTicketId(0);
  }

  function handleChange(e: React.ChangeEvent<HTMLSelectElement>): void {
    setTicketType(parseInt(e.target.value, 10));
  }

  return (
    <div className={styles.contactForm}>
      <div className={styles.fullLine}>
        {ticketId > 0 && (
          <>
            <h3>Ticket #{ticketId}</h3>
            <h2>{props.OrderInfo.TicketName}</h2>
            <button className={styles.linkButton} onClick={handleClearTicket}>
              I have a different issue I want to add.
            </button>
          </>
        )}
        {ticketId <= 0 && (
          <>
            <h2 className={styles.title}>Need to Contact Us About Your Order?</h2>
            <label htmlFor="issue-select">Choose a Subject</label>
            <div className={styles.selectContainer}>
            <select
              className="form-control"
              value={ticketType}
              onChange={handleChange}
              name="issue-select"
              id="issue-select"
            >
              <option value="0">
                -- Select a subject to help us direct your question{" "}
              </option>
              {ticketTypes.map((tt) => {
                return (
                  <option key={tt.IssueTypeId} value={tt.IssueTypeId}>
                    {tt.IssueTypeName}
                  </option>
                );
              })}
            </select>
          </div>
          </>
        )}
      </div>

      <div className={styles.fullLine}>
        <label htmlFor="Message">Tell us about your order</label>
        <textarea
          className="form-control"
          placeholder="Message (500 character limit)"
          rows={4}
          name="Message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        ></textarea>
      </div>
      {formError && <div className={styles.error}>{formError}</div>}
      <button className={styles.lookupButton} onClick={handleClick}>
        {buttonText}
      </button>
    </div>
  );
};
